import React from 'react'

const SectionTitle = ({title='some title'}) => {
  return (
    <div className='text-xl sm:text-3xl dark:text-cDarkText2 text-gray-500 uppercase font-semibold tracking-widest w-full text-center pb-2.5 drop-shadow-md'>{title}</div>
  )
}

export default SectionTitle